import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import auth from "./auth";
import services from "./services";
import careGiver from "./careGiver";
import bookings from "./bookings";
import states from "./states";
import paymentmethods from "./paymentmethods";
import chat from "./chat";
import notifications from "./notifications";
import loader from "./loader";
import favorites from "./favorites";
import wallet from "./wallet";

const rootReducer = combineReducers({
    auth,
    services,
    careGiver,
    bookings,
    states,
    paymentmethods,
    chat,
    notifications,
    loader,
    favorites,
    wallet,
});

const persistedReducer = persistReducer(
    {
        key: "root",
        storage: storage,
    },
    rootReducer
);

export default persistedReducer;
